"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var productsList_1 = require("common/global/productsList");
var unitsList_1 = require("common/global/unitsList");
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var moment_1 = __importDefault(require("moment"));
var warehouseItemsSlice_1 = require("src/features/warehouseItems/warehouseItemsSlice");
var warehouseReceiveDonationOperationsSlice_1 = require("src/features/warehouseReceiveDonationOperations/warehouseReceiveDonationOperationsSlice");
function confirmReceiveDonation(userId, dispatch, warehouseId, warehouseItems, warehouseTransferOperation, warehouseTransferOperationId) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, unitPrice, quantity, serialNumbers, assetsNumbers, productId, budgetLineId, projectId, batchNumber, expiryDate, stockNumber, storageLocation, donationCertificateNumber, dnNumber, specification, cachedProductName, from, storePoint, sameProducts, sameProductQuantity, product, newQuantity;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = warehouseTransferOperation !== null && warehouseTransferOperation !== void 0 ? warehouseTransferOperation : {}, unitPrice = _a.unitPrice, quantity = _a.quantity, serialNumbers = _a.serialNumbers, assetsNumbers = _a.assetsNumbers, productId = _a.productId, budgetLineId = _a.budgetLineId, projectId = _a.projectId, batchNumber = _a.batchNumber, expiryDate = _a.expiryDate, stockNumber = _a.stockNumber, storageLocation = _a.storageLocation, donationCertificateNumber = _a.donationCertificateNumber, dnNumber = _a.dnNumber, specification = _a.specification, cachedProductName = _a.cachedProductName, from = _a.from, storePoint = _a.storePoint;
                    sameProducts = warehouseItems.find(function (x) {
                        return x.stockNumber === stockNumber &&
                            x.productId === productId &&
                            x.projectId === projectId &&
                            x.budgetLineId === budgetLineId;
                    });
                    sameProductQuantity = sameProducts ? sameProducts.quantity : undefined;
                    product = productsList_1.globalProductsData[warehouseTransferOperation.productId];
                    newQuantity = sameProductQuantity + quantity;
                    if (!sameProducts) return [3 /*break*/, 3];
                    console.log("same product");
                    return [4 /*yield*/, dispatch((0, warehouseItemsSlice_1.editWarehouseItem)({
                            id: sameProducts.id,
                            quantity: newQuantity,
                            serialNumbers: sameProducts.serialNumbers.filter(function (x) { return !serialNumbers.includes(x); }),
                            assetsNumbers: sameProducts.assetsNumbers.filter(function (x) { return !assetsNumbers.includes(x); }),
                        }))];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, dispatch((0, warehouseReceiveDonationOperationsSlice_1.editReceiveDonationOperation)(__assign({ id: warehouseTransferOperationId }, (0, removeUndefined_1.default)({
                            updatedAt: (0, moment_1.default)(),
                            status: "accepted",
                            // notes: values.notes,
                            receivedAt: (0, moment_1.default)(),
                            receivedBy: userId,
                            after: sameProductQuantity + quantity,
                            donationCertificateNumber: donationCertificateNumber,
                        }))))];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 3:
                    console.log("not same product");
                    return [4 /*yield*/, dispatch((0, warehouseItemsSlice_1.addWarehouseItem)((0, removeUndefined_1.default)({
                            warehouseId: warehouseId,
                            productId: productId,
                            budgetLineId: budgetLineId,
                            cachedProductName: product.name,
                            cachedProductUnit: product.unitId,
                            cachedProductDescription: product.description,
                            quantity: quantity,
                            projectId: projectId,
                            createdAt: (0, moment_1.default)(),
                            updatedAt: (0, moment_1.default)(),
                            serialNumbers: serialNumbers,
                            assetsNumbers: assetsNumbers,
                            batchNumber: sameProducts
                                ? sameProducts.batchNumber
                                : batchNumber !== null && batchNumber !== void 0 ? batchNumber : null,
                            expiryDate: expiryDate ? (0, moment_1.default)(expiryDate) : null,
                            cachedProductCategory: product.categoryId,
                            cachedProductUnitName: unitsList_1.globalUnitsData[product.unitId].name,
                            cachedProductUnitPerPrescriptionQuantity: unitsList_1.globalUnitsData[product.unitId].perPrescriptionQuantity,
                            cachedProductType: product.productType,
                            stockNumber: stockNumber,
                            storageLocation: storageLocation,
                            storePoint: storePoint,
                            donationCertificateNumber: donationCertificateNumber,
                            specification: specification,
                            from: from,
                            dnNumber: dnNumber !== null && dnNumber !== void 0 ? dnNumber : "",
                            unitPrice: unitPrice,
                            type: product.serialNumbered ? "asset" : "consumable",
                        })))];
                case 4:
                    _b.sent();
                    return [4 /*yield*/, dispatch((0, warehouseReceiveDonationOperationsSlice_1.editReceiveDonationOperation)(__assign({ id: warehouseTransferOperationId }, (0, removeUndefined_1.default)({
                            updatedAt: (0, moment_1.default)(),
                            status: "accepted",
                            // notes: values.notes,
                            receivedAt: (0, moment_1.default)(),
                            receivedBy: userId,
                            after: quantity,
                            donationCertificateNumber: donationCertificateNumber,
                        }))))];
                case 5:
                    _b.sent();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.default = confirmReceiveDonation;
